/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 * Modified by David Little, 2016
 */

"object"==typeof Countries&&(Countries.updateProvinceLabel=function(e,t){if("string"==typeof e&&Countries[e]&&Countries[e].provinces){if("object"!=typeof t&&(t=document.getElementById("address_province_label"),null===t))return;t.innerHTML=Countries[e].label;var r=jQuery(t).parent();r.find("select");r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])}}),"undefined"==typeof Shopify.Cart&&(Shopify.Cart={}),Shopify.Cart.ShippingCalculator=function(){var _config={submitButton:"Calculate shipping",submitButtonDisabled:"Calculating...",templateId:"shipping-calculator-response-template",wrapperId:"wrapper-response",customerIsLoggedIn:!1,moneyFormat:"${{amount}}"},_render=function(e){var t=jQuery("#"+_config.templateId),r=jQuery("#"+_config.wrapperId);if(t.length&&r.length){var templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var n=Handlebars.compile(jQuery.trim(t.text())),a=n(e);if(jQuery(a).appendTo(r),"undefined"!=typeof Currency&&"function"==typeof Currency.convertAll){var i="";jQuery("[name=currencies]").size()?i=jQuery("[name=currencies]").val():jQuery("#currencies span.selected").size()&&(i=jQuery("#currencies span.selected").attr("data-currency")),""!==i&&Currency.convertAll(shopCurrency,i,"#wrapper-response span.money, #estimated-shipping span.money")}}},_enableButtons=function(){jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)},_disableButtons=function(){jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled","disabled").addClass("disabled")},_getCartShippingRatesForDestination=function(e){var t={type:"POST",url:"/cart/prepare_shipping_rates",data:jQuery.param({shipping_address:e}),success:_pollForCartShippingRatesForDestination(e),error:_onError};jQuery.ajax(t)},_pollForCartShippingRatesForDestination=function(e){var t=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(r,n,a){200===a.status?_onCartShippingRatesUpdate(r.shipping_rates,e):setTimeout(t,500)},error:_onError})};return t},_fullMessagesFromErrors=function(e){var t=[];return jQuery.each(e,function(e,r){jQuery.each(r,function(r,n){t.push(e+" "+n)})}),t},_onError=function(XMLHttpRequest,textStatus){jQuery("#estimated-shipping").hide(),jQuery("#estimated-shipping em").empty(),_enableButtons();var feedback="",data=eval("("+XMLHttpRequest.responseText+")");feedback=data.message?data.message+"("+data.status+"): "+data.description:"Error : "+_fullMessagesFromErrors(data).join("; ")+".","Error : country is not supported."===feedback&&(feedback="We do not ship to this destination."),_render({rates:[],errorFeedback:feedback,success:!1}),jQuery("#"+_config.wrapperId).show()},_onCartShippingRatesUpdate=function(e,t){_enableButtons();var r="";if(t.zip&&(r+=t.zip+", "),t.province&&(r+=t.province+", "),r+=t.country,e.length){"0.00"==e[0].price?jQuery("#estimated-shipping em").html("FREE"):jQuery("#estimated-shipping em").html(_formatRate(e[0].price));for(var n=0;n<e.length;n++)e[n].price=_formatRate(e[n].price)}_render({rates:e,address:r,success:!0}),jQuery("#"+_config.wrapperId+", #estimated-shipping").fadeIn()},_formatRate=function(e){function t(e,t){return"undefined"==typeof e?t:e}function r(e,r,n,a){if(r=t(r,2),n=t(n,","),a=t(a,"."),isNaN(e)||null==e)return 0;e=(e/100).toFixed(r);var i=e.split("."),o=i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+n),s=i[1]?a+i[1]:"";return o+s}if("function"==typeof Shopify.formatMoney)return Shopify.formatMoney(e,_config.moneyFormat);"string"==typeof e&&(e=e.replace(".",""));var n="",a=/\{\{\s*(\w+)\s*\}\}/,i=_config.moneyFormat;switch(i.match(a)[1]){case"amount":n=r(e,2);break;case"amount_no_decimals":n=r(e,0);break;case"amount_with_comma_separator":n=r(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":n=r(e,0,".",",")}return i.replace(a,n)};return _init=function(){new Shopify.CountryProvinceSelector("address_country","address_province",{hideElement:"address_province_container"});var e=jQuery("#address_country"),t=jQuery("#address_province_label").get(0);"undefined"!=typeof Countries&&(Countries.updateProvinceLabel(e.val(),t),e.change(function(){Countries.updateProvinceLabel(e.val(),t)})),jQuery(".get-rates").click(function(){_disableButtons(),jQuery("#"+_config.wrapperId).empty().hide();var e={};e.zip=jQuery("#address_zip").val()||"",e.country=jQuery("#address_country").val()||"",e.province=jQuery("#address_province").val()||"",_getCartShippingRatesForDestination(e)}),_config.customerIsLoggedIn&&jQuery(".get-rates:eq(0)").trigger("click")},{show:function(e){e=e||{},jQuery.extend(_config,e),jQuery(function(){_init()})},getConfig:function(){return _config},formatRate:function(e){return _formatRate(e)}}}();

Shopify.Cart.ShippingCalculator.show({
  submitButton: theme.strings.shippingCalcSubmitButton,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
  moneyFormat: theme.strings.shippingCalcMoneyFormat
});


/* Cart mutations go through the JSON cart API.
   The previous implementation wrote the input then synthesised a click on the
   form's name="update" submit, producing a full POST /cart navigation that the
   storefront answers with 403. Verified 2026-09-19: POST /cart -> 403 while
   POST /cart/change.js -> 200 on the same session. */
(function () {
  var $feedback, strings, pending = false, lastGood = {};

  function readStrings() {
    var $n = $('#CartApiFeedback');
    return {
      stock:   $n.data('msg-stock')   || 'Die gewünschte Menge ist nicht verfügbar.',
      network: $n.data('msg-network') || 'Verbindungsfehler. Bitte erneut versuchen.',
      generic: $n.data('msg-generic') || 'Der Warenkorb konnte nicht aktualisiert werden.'
    };
  }

  function showError(message) {
    if (!$feedback || !$feedback.length) return;
    $feedback.text(message).attr('hidden', null).show();
  }

  function clearError() {
    if (!$feedback || !$feedback.length) return;
    $feedback.text('').hide();
  }

  function setPending(on) {
    pending = on;
    var $checkout = $('input[name="checkout"]');
    if (on) {
      $checkout.prop('disabled', true).addClass('disabled');
    } else {
      $checkout.prop('disabled', false).removeClass('disabled');
    }
  }

  function rememberQuantities() {
    $('input[name="updates[]"]').each(function () {
      lastGood[$(this).data('line')] = $(this).val();
    });
  }

  function restore(line) {
    if (lastGood[line] === undefined) return;
    $('input[name="updates[]"][data-line="' + line + '"]').val(lastGood[line]);
  }

  /* Shopify renders both sections into the change.js response, so a quantity
     change costs one request. Totals always come from Shopify, never from
     client-side arithmetic. */
  function applySections(sections) {
    var fresh = null;
    if (sections && sections['main-cart-template']) {
      var parsed = new DOMParser().parseFromString(sections['main-cart-template'], 'text/html');
      fresh = parsed.querySelector('.main-cart-template') || parsed.body.firstElementChild;
    }
    var current = document.querySelector('.main-cart-template');
    if (!fresh || !current) {
      window.location.assign('/cart');
      return;
    }
    current.innerHTML = fresh.innerHTML;
    updateCartCount(sections.header);
    bind();
    rememberQuantities();
  }

  /* The cart badge sits in the header section, which the cart section swap does
     not touch -- without this it stays stale until the next page load. The theme
     renders the nav twice, so #CartCount is not unique and jQuery's $('#id')
     shortcut would reach only the first one; querySelectorAll gets both. */
  function updateCartCount(headerHtml) {
    if (!headerHtml) return;
    var parsed = new DOMParser().parseFromString(headerHtml, 'text/html');
    var fresh = parsed.querySelector('#CartCount');
    if (!fresh) return;
    var nodes = document.querySelectorAll('#CartCount');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].innerHTML = fresh.innerHTML;
      nodes[i].className = fresh.className;
      nodes[i].setAttribute('data-cart_item_count', fresh.getAttribute('data-cart_item_count') || '0');
    }
  }

  function changeLine(line, quantity) {
    if (pending) return;
    if (line === undefined || line === null || line === '') return;
    setPending(true);
    clearError();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        sections: 'main-cart-template,header',
        sections_url: '/cart'
      })
    }).then(function (response) {
      /* Read as text first: a 403 answers with an HTML body, and JSON parsing
         it would throw before the error could ever be shown. */
      return response.text().then(function (body) {
        var data = null;
        if (body) { try { data = JSON.parse(body); } catch (e) { data = null; } }
        return { ok: response.ok, status: response.status, data: data };
      });
    }).then(function (result) {
      if (!result.ok) {
        var message = (result.data && (result.data.description || result.data.message)) ||
                      (result.status === 422 ? strings.stock : strings.generic);
        showError(message);
        restore(line);
        setPending(false);
        return;
      }
      applySections(result.data && result.data.sections);
      setPending(false);
    }).catch(function () {
      showError(strings.network);
      restore(line);
      setPending(false);
    });
  }

  function lineOf(el) {
    var $row = $(el).closest('.cart__row');
    var $input = $row.find('input[name="updates[]"]');
    return { line: $input.data('line'), $input: $input };
  }

  function bind() {
    $feedback = $('#CartApiFeedback');
    strings = readStrings();

    $('.qtyplus1').off('click.cartapi').on('click.cartapi', function (event) {
      event.preventDefault();
      var ctx = lineOf(this);
      var current = parseInt(ctx.$input.val(), 10);
      changeLine(ctx.line, (isNaN(current) ? 0 : current) + 1);
    });

    $('.qtyminus1').off('click.cartapi').on('click.cartapi', function (event) {
      event.preventDefault();
      var ctx = lineOf(this);
      var current = parseInt(ctx.$input.val(), 10);
      changeLine(ctx.line, Math.max(0, (isNaN(current) ? 1 : current) - 1));
    });

    /* change/blur, not keystrokes */
    $('input[name="updates[]"]').off('change.cartapi').on('change.cartapi', function () {
      var line = $(this).data('line');
      var value = parseInt($(this).val(), 10);
      if (isNaN(value) || value < 0) { restore(line); return; }
      changeLine(line, value);
    });

    $('.cart__remove').off('click.cartapi').on('click.cartapi', function (event) {
      event.preventDefault();
      changeLine($(this).data('line'), 0);
    });
  }

  $(function () {
    bind();
    rememberQuantities();

    /* One central submit handler. Checkout still submits natively once nothing
       is in flight; Update and implicit Enter submission are routed to the API.
       Implicit submission reports no submitter, so a null submitter is Update. */
    $(document).on('submit', 'form.cart', function (event) {
      var submitter = event.originalEvent && event.originalEvent.submitter;
      var isCheckout = submitter && submitter.name === 'checkout';

      if (isCheckout) {
        if (pending) { event.preventDefault(); }
        return;
      }

      event.preventDefault();
      if (pending) return;

      var $changed = $('input[name="updates[]"]').filter(function () {
        return String($(this).val()) !== String(lastGood[$(this).data('line')]);
      }).first();

      if (!$changed.length) { clearError(); return; }
      var value = parseInt($changed.val(), 10);
      if (isNaN(value) || value < 0) { restore($changed.data('line')); return; }
      changeLine($changed.data('line'), value);
    });
  });
})();

function shippingCall() {    
  var x = document.getElementById("shipping-calculator-block");
  if (x.style.display === "none") {
    x.style.display = "block";    
  } else {
    x.style.display = "none";    
  }
}


$(".cart_heading").on('click', function() {
 if (jQuery(this).hasClass('clicked')) {
   $(this).removeClass('clicked');
  }
  else
  {
   $(this).addClass('clicked');
  }
});